import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import './CursoDetalle.css';
import { useCart } from '../../context/CartContext';
import { useAuthUser } from '../../context/AuthUserContext';


const AULA_URL  = 'https://centrocomunicar.com/virtual/login/index.php';
const API_BASE  = 'https://centrocomunicar.com/api-comunicar/endpoints/courses.php';
const API_DETALLE = 'https://centrocomunicar.com/api-comunicar/endpoints/curso_detalle.php';
const WA_NUMBER = '51940686868';

/* ── Logo ── */
const LogoComunicar = ({ height = 40 }) => (
  <img 
    src="/images/logo_centro.png" 
    alt="Comunicar" 
    style={{ height: height, width: 'auto', display: 'block' }}
  />
);

/* ── Icons ── */
const IconArrow        = () => (<svg viewBox="0 0 20 20" fill="none" width="16" height="16"><path d="M4 10h12M11 6l5 4-5 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconArrowLeft    = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M19 12H5M12 19l-7-7 7-7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconPlay         = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/><path d="M10 8l6 4-6 4V8z" fill="currentColor"/></svg>);
const IconLive         = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><circle cx="12" cy="12" r="3" fill="currentColor"/><path d="M8.5 8.5a5 5 0 000 7M15.5 8.5a5 5 0 010 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconUsers        = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2"/><path d="M3 21v-2a4 4 0 014-4h4a4 4 0 014 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M16 3.13a4 4 0 010 7.75M21 21v-2a4 4 0 00-3-3.87" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconCalendar     = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><rect x="3" y="4" width="18" height="18" rx="3" stroke="currentColor" strokeWidth="2"/><path d="M3 9h18M8 2v4M16 2v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconCheck        = () => (<svg viewBox="0 0 20 20" fill="none" width="16" height="16" style={{flexShrink:0}}><circle cx="10" cy="10" r="9" fill="rgba(130,216,179,.25)"/><path d="M6 10l3 3 5-5" stroke="#4db88a" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconMonitor      = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><rect x="2" y="3" width="20" height="14" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M8 21h8M12 17v4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconWhatsapp     = () => (<svg viewBox="0 0 24 24" fill="none" width="20" height="20"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconExternalLink = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/><path d="M15 3h6v6M10 14L21 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconShare        = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><circle cx="18" cy="5" r="3" stroke="currentColor" strokeWidth="2"/><circle cx="6" cy="12" r="3" stroke="currentColor" strokeWidth="2"/><circle cx="18" cy="19" r="3" stroke="currentColor" strokeWidth="2"/><path d="M8.59 13.51l6.83 3.98M15.41 6.51l-6.82 3.98" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconCopy         = () => (<svg viewBox="0 0 24 24" fill="none" width="16" height="16"><rect x="9" y="9" width="13" height="13" rx="2" stroke="currentColor" strokeWidth="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconCart         = () => (<svg viewBox="0 0 24 24" fill="none" width="17" height="17"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M3 6h18M16 10a4 4 0 01-8 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);
const IconCartPlus     = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M3 6h18M16 10a4 4 0 01-8 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M12 13v4M10 15h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>);
const IconBag          = () => (<svg viewBox="0 0 24 24" fill="none" width="18" height="18"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/><path d="M3 6h18M16 10a4 4 0 01-8 0" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>);

/* ── Helpers ── */
function detectTipo(curso) {
  const txt = ((curso?.fullname||'') + ' ' + (curso?.shortname||'')).toLowerCase();
  if (txt.includes('vivo')||txt.includes('live')||txt.includes('taller')||txt.includes('webinar')) return 'vivo';
  return 'grabado';
}
function detectCategoria(curso) {
  if (curso?.categoria) return curso.categoria;
  const txt = (curso?.fullname||'').toLowerCase();
  if (txt.includes('lenguaje'))  return 'Lenguaje';
  if (txt.includes('habla')||txt.includes('fonol')||txt.includes('tartam')) return 'Habla';
  if (txt.includes('tea')||txt.includes('autis')) return 'TEA';
  if (txt.includes('aprendizaje')||txt.includes('dislexia')) return 'Aprendizaje';
  return 'Lenguaje';
}
const catColorMap = { lenguaje:'verde', tea:'azul', habla:'amarillo', tartamudez:'rosa', aprendizaje:'morado' };
function getCatClass(cat) {
  return catColorMap[(cat||'').toLowerCase().replace(/\s/g,'')] || 'verde';
}

/* ── Toast carrito ── */
function ToastCarrito({ item, onVer, onCerrar }) {
  useEffect(() => { const t = setTimeout(onCerrar, 3500); return () => clearTimeout(t); }, [onCerrar]);
  return (
    <div style={{position:'fixed',bottom:'2rem',right:'2rem',zIndex:9999,background:'#111614',color:'#fff',borderRadius:16,padding:'1rem 1.2rem',boxShadow:'0 8px 32px rgba(0,0,0,.35)',display:'flex',alignItems:'center',gap:'1rem',maxWidth:320,width:'90%'}}>
      <div style={{width:38,height:38,borderRadius:10,background:'#82D8B3',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}><IconCheck/></div>
      <div style={{flex:1,minWidth:0}}>
        <div style={{fontSize:'.72rem',color:'rgba(255,255,255,.5)',marginBottom:'.1rem'}}>Agregado al carrito</div>
        <div style={{fontSize:'.86rem',fontWeight:700,overflow:'hidden',textOverflow:'ellipsis',whiteSpace:'nowrap'}}>{item?.titulo}</div>
      </div>
      <button onClick={onVer} style={{background:'#82D8B3',color:'#111614',border:'none',borderRadius:100,padding:'.4rem .85rem',fontFamily:'inherit',fontWeight:700,fontSize:'.75rem',cursor:'pointer',whiteSpace:'nowrap',flexShrink:0}}>
        Ver carrito
      </button>
    </div>
  );
}

/* ════════════════════════════════════════ */
export default function CursoDetalle() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { agregarItem, estaEnCarrito, totalItems, ultimoAgregado, limpiarUltimoAgregado } = useCart();
  const { estaLogueado, usuario } = useAuthUser();


  const [curso,      setCurso]      = useState(null);
  const [loading,    setLoading]    = useState(true);
  const [error,      setError]      = useState(null);
  const [copied,     setCopied]     = useState(false);
  const [detalle,    setDetalle]    = useState(null);
  const [materiales, setMateriales] = useState([]);

  useEffect(() => { window.scrollTo(0, 0); fetchCurso(); fetchDetalle(); }, [id]);

  const fetchDetalle = async () => {
    try {
      const r = await fetch(`${API_DETALLE}?action=get&moodle_id=${id}`);
      const j = await r.json();
      if (j.success) { setDetalle(j.data?.detalle || null); setMateriales(j.data?.materiales || []); }
    } catch(e) {}
  };

  const fetchCurso = async () => {
    setLoading(true); setError(null);
    try {
      const res  = await fetch(`${API_BASE}?action=detail&courseid=${id}`);
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const json = await res.json();
      if (!json.success) throw new Error(json.message || 'Error al obtener curso');
      setCurso(json.data);
    } catch(err) { setError(err.message); }
    finally { setLoading(false); }
  };

  const copyLink = () => { navigator.clipboard.writeText(window.location.href); setCopied(true); setTimeout(() => setCopied(false), 2000); };

  /* Loading */
  if (loading) return (
    <div className="cd-page">
      <nav className="nav">
        <Link to="/" className="nav__logo"><LogoComunicar height={44}/></Link>
      </nav>
      <div className="cd-loading"><div className="cd-loading__spinner"/><p>Cargando formación…</p></div>
    </div>
  );

  /* Error */
  if (error) return (
    <div className="cd-page">
      <nav className="nav">
        <Link to="/" className="nav__logo"><LogoComunicar height={44}/></Link>
      </nav>
      <div className="cd-error">
        <p>⚠️ {error}</p>
        <Link to="/formaciones" className="cd-btn-back"><IconArrowLeft/> Volver a formaciones</Link>
      </div>
    </div>
  );

  const tipo    = detectTipo(curso);
  const cat     = detectCategoria(curso);
  const catCls  = getCatClass(cat);
  const alumnos = curso.estudiantes?.length || curso.total_estudiantes || 0;
  const desc = curso.descripcion_custom || detalle?.descripcion || curso.summary_text || curso.summary?.replace(/<[^>]+>/g,'') || '';
  const precio  = parseFloat(curso.precio_web || 0);
  const enCarrito = estaEnCarrito('curso-' + curso.id);

  const waMsg = `Hola, me interesa la formación: *${curso.fullname}*. ¿Pueden darme más información?`;
  const waUrl = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(waMsg)}`;

  const temas = desc
    .split(/[\n•\-]/g)
    .map(t => t.trim())
    .filter(t => t.length > 8 && t.length < 120)
    .slice(0, 6);

  return (
    <div className="cd-page">

      {/* Toast carrito */}
      {ultimoAgregado && (
        <ToastCarrito
          item={ultimoAgregado}
          onVer={() => { navigate('/carrito'); limpiarUltimoAgregado(); }}
          onCerrar={limpiarUltimoAgregado}
        />
      )}

      {/* ── NAV actualizado ── */}
      <nav className="nav">
        <Link to="/" className="nav__logo"><LogoComunicar height={44}/></Link>
        <div className="nav__links">
          <Link to="/">Inicio</Link>
          <Link to="/formaciones" style={{color:'var(--verde-dk)',fontWeight:700}}>Cursos</Link>
          <Link to="/recursos">Materiales</Link>
          <Link to="/comunidad">Comunidad</Link>
          <Link to="/articulos">Blog</Link>
          <a href="https://centrocomunicar.com/virtual/login/index.php"
            target="_blank" rel="noopener noreferrer"
            className="nav__aula-btn">
            <span className="aula-icon">📖</span>
            Aula Virtual
          </a>
        </div>
        <div className="nav__actions">
          <Link to="/carrito"
            style={{position:'relative',display:'flex',alignItems:'center',padding:'.4rem .7rem',borderRadius:100,border:'1.5px solid rgba(139,202,175,.3)',color:'var(--gris)',transition:'all .2s'}}
            title="Ver carrito">
            <IconCart/>
            {totalItems > 0 && (
              <span style={{position:'absolute',top:-6,right:-6,background:'#8BCAAF',color:'#032D29',borderRadius:'50%',width:18,height:18,fontSize:'.62rem',fontWeight:800,display:'flex',alignItems:'center',justifyContent:'center',lineHeight:1}}>
                {totalItems > 9 ? '9+' : totalItems}
              </span>
            )}
          </Link>
          {estaLogueado
            ? <Link to="/mi-cuenta" className="nav__mi-cuenta">● {usuario?.nombre}</Link>
            : <Link to="/login" className="nav__login">Iniciar sesión</Link>
          }
        </div>
      </nav>

      {/* ── BREADCRUMB ── */}
      <div className="cd-breadcrumb">
        <Link to="/formaciones"><IconArrowLeft/> Volver a formaciones</Link>
        <span>/</span>
        <span>{curso.fullname}</span>
      </div>

      {/* ── HERO ── */}
      <div className="cd-hero">
      <div className={`cd-hero__thumb cd-thumb--${catCls}`} style={(curso.imagen_custom || curso.imagen_url) ? {backgroundImage:`url(${curso.imagen_custom || curso.imagen_url})`,backgroundSize:'cover',backgroundPosition:'center'} : {}}>
      {!curso.imagen_custom && !curso.imagen_url && (<div className="cd-hero__thumb-icon">{tipo==='vivo' ? <IconLive/> : <IconPlay/>}</div>)}
          <div className="cd-hero__thumb-overlay"/>
        </div>

        <div className="cd-hero__content">
          <div className="cd-hero__badges">
            <span className={`cd-badge cd-badge--cat cd-badge--${catCls}`}>{cat}</span>
            <span className={`cd-badge ${tipo==='vivo'?'cd-badge--live':'cd-badge--grabado'}`}>
              {tipo==='vivo' ? <><IconLive/> En vivo</> : <><IconPlay/> Grabado</>}
            </span>
            {!curso.activo && <span className="cd-badge cd-badge--inactivo">Inactivo</span>}
          </div>
          <h1 className="cd-hero__titulo">{curso.fullname}</h1>
          {curso.shortname && <p className="cd-hero__shortname">Código: <strong>{curso.shortname}</strong></p>}
          <div className="cd-hero__meta">
            <span><IconUsers/>{alumnos} estudiantes inscritos</span>
            <span><IconCalendar/>Inicio: {curso.fecha_inicio || curso.fecha_creacion}</span>
          </div>
          {desc && <p className="cd-hero__desc">{desc.length > 300 ? desc.slice(0,300)+'…' : desc}</p>}

          {/* Precio */}
          {precio > 0 && (
            <div style={{display:'flex',alignItems:'center',gap:'.8rem',margin:'1rem 0'}}>
              <span style={{fontSize:'1.6rem',fontWeight:800,color:'#111614'}}>S/. {precio.toFixed(0)}</span>
              {curso.precio_anterior && (
                <s style={{fontSize:'1rem',color:'#9ca3af'}}>S/. {parseFloat(curso.precio_anterior).toFixed(0)}</s>
              )}
            </div>
          )}

          {/* Acciones */}
          <div className="cd-hero__actions">
            {/* Botón carrito — solo si tiene precio */}
            {precio > 0 && (
              enCarrito ? (
                <Link to="/carrito" className="cd-btn-primary" style={{background:'#4db88a',borderColor:'#4db88a'}}>
                  <IconBag/> Ver carrito
                </Link>
              ) : (
                <button
                  className="cd-btn-primary"
                  
                  onClick={() => {
                    if (!estaLogueado) { navigate('/login?redirect=/formaciones'); return; }
                    agregarItem({
                      id:      'curso-' + curso.id,
                      titulo:  curso.fullname,
                      precio:  precio,
                      tipo:    'curso',
                      color:   'verde',
                      imagen:  curso.imagen_url || null,
                      digital: true,
                    });
                  }}


                  style={{border:'none',cursor:'pointer',fontFamily:'inherit'}}
                >
                  <IconCartPlus/> Agregar al carrito
                </button>
              )
            )}
            <a href={AULA_URL} target="_blank" rel="noopener noreferrer" className="cd-btn-primary" style={precio > 0 ? {background:'transparent',color:'#111614',border:'2px solid rgba(130,216,179,.4)'} : {}}>
              <IconMonitor/> Acceder al curso <IconExternalLink/>
            </a>
            <a href={waUrl} target="_blank" rel="noopener noreferrer" className="cd-btn-whatsapp">
              <IconWhatsapp/> Consultar por WhatsApp
            </a>
          </div>

          <div className="cd-hero__share">
            <button className="cd-share-btn" onClick={copyLink}>
              {copied ? '✓ Enlace copiado' : <><IconCopy/> Copiar enlace</>}
            </button>
            <a href={`https://wa.me/?text=${encodeURIComponent(curso.fullname + ' ' + window.location.href)}`} target="_blank" rel="noopener noreferrer" className="cd-share-btn cd-share-btn--wa">
              <IconShare/> Compartir
            </a>
          </div>
        </div>
      </div>

      {/* ── CUERPO ── */}
      <div className="cd-body">
        <div className="cd-main">

          {desc && (
            <div className="cd-card">
              <h2>Sobre esta formación</h2>
              <p className="cd-desc-full">{desc}</p>
            </div>
          )}

          {detalle?.temario && detalle.temario.length > 0 && (
            <div className="cd-card">
              <h2>Temario del curso</h2>
              <div className="cd-temario">
                {detalle.temario.map((mod, mi) => (
                  <div className="cd-modulo" key={mi}>
                    <div className="cd-modulo__head">
                      <span className="cd-modulo__num">{mi+1}</span>
                      <strong>{mod.modulo}</strong>
                    </div>
                    {mod.temas && mod.temas.length > 0 && (
                      <ul className="cd-temas">
                        {mod.temas.filter(Boolean).map((t, ti) => (<li key={ti}><IconCheck/>{t}</li>))}
                      </ul>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}

         {/* {(!detalle?.temario || detalle.temario.length === 0) && temas.length > 0 && (
            <div className="cd-card">
              <h2>Contenido del curso</h2>
              <ul className="cd-temas">{temas.map((t,i) => <li key={i}><IconCheck/>{t}</li>)}</ul>
            </div>
          )}
 */}
          {detalle?.instructor_nombre && (
            <div className="cd-card cd-card--instructor">
              <h2>Instructor</h2>
              <div className="cd-instructor">
                {detalle.instructor_foto && <img src={detalle.instructor_foto} alt={detalle.instructor_nombre} className="cd-instructor__foto"/>}
                <div>
                  <strong className="cd-instructor__nombre">{detalle.instructor_nombre}</strong>
                  {detalle.instructor_cargo && <span className="cd-instructor__cargo">{detalle.instructor_cargo}</span>}
                  {detalle.instructor_bio   && <p className="cd-instructor__bio">{detalle.instructor_bio}</p>}
                </div>
              </div>
            </div>
          )}

          {materiales.length > 0 && (
            <div className="cd-card">
              <h2>Materiales del curso <span className="cd-count">{materiales.length}</span></h2>
              <div className="cd-materiales">
                {materiales.map(mat => (
                  <a key={mat.id} href={mat.archivo_url} target="_blank" rel="noopener noreferrer" className="cd-material-item">
                    <span className="cd-material-icon">{mat.tipo==='pdf'?'📄':mat.tipo==='word'?'📝':mat.tipo==='ppt'?'📊':mat.tipo==='excel'?'📈':mat.tipo==='video'?'🎥':'📎'}</span>
                    <div className="cd-material-info">
                      <strong>{mat.nombre}</strong>
                      {mat.descripcion && <span>{mat.descripcion}</span>}
                      <span className="cd-material-meta">{mat.tipo?.toUpperCase()}{mat.tamano_kb && ` · ${mat.tamano_kb > 1024 ? (mat.tamano_kb/1024).toFixed(1)+'MB' : mat.tamano_kb+'KB'}`}</span>
                    </div>
                    <span className="cd-material-dl">↓ Descargar</span>
                  </a>
                ))}
              </div>
            </div>
          )}

          {curso.estudiantes && curso.estudiantes.length > 0 && (
            <div className="cd-card cd-card--estudiantes">
              <h2>Estudiantes inscritos</h2>
              <div className="cd-est-resumen">
                <div className="cd-est-num">{curso.estudiantes.length}</div>
                <div><strong>Personas inscritas en esta formación</strong><p>Únete a quienes ya están aprendiendo con nosotros</p></div>
              </div>
              <div className="cd-est-barra-wrap">
                <div className="cd-est-barra">
                  <div className="cd-est-barra__fill" style={{width:`${Math.min((curso.estudiantes.length/100)*100,100)}%`}}/>
                </div>
                <span className="cd-est-barra__label">{curso.estudiantes.length} de 100 plazas ocupadas</span>
              </div>
              <div className="cd-est-avatares">
                {[...Array(Math.min(curso.estudiantes.length,8))].map((_,i) => (
                  <div key={i} className="cd-est-avatar" style={{'--i':i}}>{String.fromCharCode(65+(i%26))}</div>
                ))}
                {curso.estudiantes.length > 8 && <div className="cd-est-avatar cd-est-avatar--more">+{curso.estudiantes.length - 8}</div>}
              </div>
            </div>
          )}
        </div>

        {/* ── SIDEBAR ── */}
        <aside className="cd-sidebar">
          <div className="cd-card cd-card--sticky cd-card--cta">
          <div className={`cd-cta-thumb cd-thumb--${catCls}`} style={(curso.imagen_custom || curso.imagen_url) ? {backgroundImage:`url(${curso.imagen_custom || curso.imagen_url})`,backgroundSize:'cover',backgroundPosition:'center',height:120} : {}}>
  {!curso.imagen_custom && !curso.imagen_url && (tipo==='vivo' ? <IconLive/> : <IconPlay/>)}
</div>
            <div className="cd-cta-info">
              <span className="cd-cta-tipo">{tipo==='vivo'?'Formación en vivo':'Curso grabado'}</span>
              <p className="cd-cta-titulo">{curso.fullname}</p>
            </div>

            {/* Precio en sidebar */}
            {precio > 0 && (
              <div style={{textAlign:'center',padding:'.5rem 0'}}>
                <span style={{fontSize:'1.5rem',fontWeight:800,color:'#111614'}}>S/. {precio.toFixed(0)}</span>
                {curso.precio_anterior && (
                  <s style={{fontSize:'.9rem',color:'#9ca3af',marginLeft:'.5rem'}}>S/. {parseFloat(curso.precio_anterior).toFixed(0)}</s>
                )}
              </div>
            )}

            <div className="cd-cta-stats">
              <div><IconUsers/><span>{alumnos} inscritos</span></div>
              <div><IconCalendar/><span>{curso.fecha_inicio || curso.fecha_creacion}</span></div>
            </div>

            {/* Botón carrito en sidebar */}
            {precio > 0 && (
              enCarrito ? (
                <Link to="/carrito" className="cd-btn-primary cd-btn-full" style={{background:'#4db88a',marginBottom:'.6rem',display:'flex',alignItems:'center',justifyContent:'center',gap:'.4rem'}}>
                  <IconBag/> Ver carrito
                </Link>
              ) : (
                <button
                  className="cd-btn-primary cd-btn-full"
                  style={{border:'none',cursor:'pointer',fontFamily:'inherit',marginBottom:'.6rem',display:'flex',alignItems:'center',justifyContent:'center',gap:'.4rem',width:'100%'}}                 
                 
                  onClick={() => {
                    if (!estaLogueado) { navigate('/login?redirect=/formaciones'); return; }
                    agregarItem({
                      id:      'curso-' + curso.id,
                      titulo:  curso.fullname,
                      precio:  precio,
                      tipo:    'curso',
                      color:   'verde',
                      imagen:  curso.imagen_url || null,
                      digital: true,
                    });
                  }}



                >
                  <IconCartPlus/> Agregar al carrito
                </button>
              )
            )}

            <a href={AULA_URL} target="_blank" rel="noopener noreferrer" className="cd-btn-primary cd-btn-full">
              <IconMonitor/> Ir al Aula Virtual <IconExternalLink/>
            </a>
            <a href={waUrl} target="_blank" rel="noopener noreferrer" className="cd-btn-whatsapp cd-btn-full">
              <IconWhatsapp/> Consultar por WhatsApp
            </a>
            <p className="cd-cta-nota">Se abrirá en una nueva pestaña · Moodle</p>
          </div>

          <div className="cd-card">
            <h3>Información</h3>
            <div className="cd-info-list">
              {[
                ['Tipo',       tipo==='vivo'?'En vivo':'Grabado'],
                ['Categoría',  cat],
                ['Estudiantes',alumnos],
                ['Inicio',     curso.fecha_inicio || curso.fecha_creacion],
                ['Estado',     curso.activo ? 'Activo' : 'Inactivo'],
                ...(curso.shortname ? [['Código', curso.shortname]] : []),
                ...(precio > 0 ? [['Precio', `S/. ${precio.toFixed(2)}`]] : []),
              ].map(([label, val]) => (
                <div className="cd-info-item" key={label}>
                  <span>{label}</span>
                  <strong>{val}</strong>
                </div>
              ))}
            </div>
          </div>

          <div className="cd-card cd-card--wa">
            <IconWhatsapp/>
            <div>
              <strong>¿Tienes preguntas?</strong>
              <p>Escríbenos por WhatsApp y te respondemos en minutos.</p>
            </div>
            <a href={waUrl} target="_blank" rel="noopener noreferrer" className="cd-btn-whatsapp cd-btn-full">
              Escribir ahora <IconArrow/>
            </a>
          </div>
        </aside>
      </div>

      {/* ── FOOTER ── */}
      <footer className="footer">
        <div className="footer__top">
          <div className="footer__brand">
            <p className="footer__brand-desc">Cursos especializados y materiales terapéuticos para profesionales y familias que trabajan el desarrollo del lenguaje.</p>
            <div className="footer__social">
            <a href="https://www.instagram.com/comunicar_terapias?fbclid=IwY2xjawRS90JleHRuA2FlbQIxMABicmlkETFsTWNRclhmY2hiTzRvTndDc3J0YwZhcHBfaWQQMjIyMDM5MTc4ODIwMDg5MgABHq32WKTsoRBD35O1FJxG61CJ733vEK4GryiNvmMbbLmdCCEyxitSoS8ns6QR_aem_7hu4_QjxX4oXanDtpj-WpQ" className="footer__social-btn" aria-label="Instagram"><svg viewBox="0 0 24 24" fill="none" width="17" height="17"><rect x="2" y="2" width="20" height="20" rx="5" stroke="currentColor" strokeWidth="2"/><circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor"/></svg></a>
              <a href="https://www.facebook.com/comunicar.terapias" className="footer__social-btn" aria-label="Facebook"><svg viewBox="0 0 24 24" fill="none" width="17" height="17"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg></a>
              <a href="https://api.whatsapp.com/send/?phone=51940686868&text&type=phone_number&app_absent=0" className="footer__social-btn" aria-label="WhatsApp"><svg viewBox="0 0 24 24" fill="none" width="17" height="17"><path d="M21 11.5a8.38 8.38 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.38 8.38 0 01-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.38 8.38 0 013.8-.9h.5a8.48 8.48 0 018 8v.5z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg></a>
            </div>
          </div>
          <div className="footer__cols">
            <div className="footer__col">
              <h4>Cursos</h4>
              <Link to="/formaciones">Cursos grabados</Link>
              <Link to="/formaciones">Cursos en vivo</Link>
              <a href={AULA_URL} target="_blank" rel="noopener noreferrer">Aula virtual ↗</a>
            </div>
            <div className="footer__col">
              <h4>Materiales</h4>
              <Link to="/recursos">Imprimibles</Link>
              <Link to="/recursos">Cuadernillos</Link>
              <Link to="/recursos">Juegos terapéuticos</Link>
            </div>
            <div className="footer__col">
              <h4>Comunidad</h4>
              <Link to="/comunidad">Redes sociales</Link>
              <Link to="/comunidad">Boletín mensual</Link>
            </div>
          </div>
          <div className="footer__newsletter">
            <h4>Recibe novedades</h4>
            <p>Nuevos cursos y materiales en tu correo.</p>
            <div className="footer__form">
              <input type="email" placeholder="tu@correo.com" className="footer__input"/>
              <button className="footer__submit"><IconArrow/></button>
            </div>
            <div className="footer__legal-links">
              <Link to="/atencion-cliente">Atención al cliente</Link>
              <Link to="/legal">Legal</Link>
              <Link to="/libro-reclamaciones">Libro de reclamaciones</Link>
            </div>
          </div>
        </div>
        <div className="footer__bottom">
          <p>© 2026 Comunicar – Desarrollo y Lenguaje. Todos los derechos reservados.</p>
          <p style={{fontSize:'.75rem',color:'rgba(255,255,255,.3)',marginTop:'.3rem'}}>Dirección: Teniente Carlos Moore 1386, Cercado de Lima</p>
          <div className="footer__legal">
            <Link to="/legal">Privacidad</Link>
            <Link to="/legal">Términos y condiciones</Link>
            <Link to="/politica-devoluciones">Política de devoluciones</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}